import EcranInstructions from "@/modules/autres/EcranInstructions";
import { useState, useEffect, useRef, useCallback } from "react";
import { useFullscreen } from "@mantine/hooks";
import { useLocation, useParams } from "react-router-dom";
import ExplorationTest from "@/modules/bilan/Exploration"; // Composant de test d'exploration
import { toast } from "react-toastify";

export const LauncherExploration = ({
  onModuleEnd,
  saveFieldSession,
}: {
  onModuleEnd: () => void;
  saveFieldSession: (fieldsToUpdate: { field: string; value: string | number | number[] | Date; }[]) => void;
}) => {
  const [moduleActif, setModuleActif] = useState(false);
  const { toggle } = useFullscreen();
  const isPausedAndNotFullScreenRef = useRef<boolean>(
    !document.fullscreenElement
  );
  const [isPaused, setIsPaused] = useState(true);

  type CombinedTrialData = {
    positions: Target[]; // Toutes les positions des cibles pour chaque essai
    success: boolean; // Succès ou échec
    results: {
      trialNumber: number;
      timeTaken: number; // Temps en millisecondes
      clickedTargetPosition: string; // Position cliquée (e.g., "A12")
    }[];
  };

  // Utilisez une référence pour stocker les données combinées
  const trialResults = useRef<CombinedTrialData>({
    positions: [],
    results: [],
    success: false,
  });
  const totalTrials = 30; // Define the total number of trials

  const lancerModule = useCallback(() => {
    setModuleActif(true);
    setIsPaused(false);
    // toggle(); // Enter fullscreen mode
  }, []);

  const { patientId } = useParams();
  const location = useLocation();
  const sessionForm = location.state;

  const caseSize = localStorage.getItem("selectedCaseSizePx");

  useEffect(() => {
    const handleFullscreenChange = () => {
      isPausedAndNotFullScreenRef.current = !document.fullscreenElement;
    };

    const handleKeyPress = async (event: { key: string }) => {
      if ((event.key === "p" || event.key === "Escape") && !isPaused) {
        toggle();
        isPausedAndNotFullScreenRef.current =
          !isPausedAndNotFullScreenRef.current;
      } else if (event.key === " ") {
        if (!moduleActif) {
          lancerModule(); // Start the test when the user presses space
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        // if (moduleActif && !isPausedAndNotFullScreenRef.current) {
        //   setIsPaused(true);
        //   toggle();
        // }
      }
    };

    window.addEventListener("fullscreenchange", handleFullscreenChange);
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [
    moduleActif,
    isPausedAndNotFullScreenRef,
    toggle,
    isPaused,
    patientId,
    sessionForm,
    lancerModule,
  ]);

  type Target = {
    position: string;
    isTarget: boolean;
  };

  type TrialData = {
    trialNumber: number;
    positions: Target[];
    timeTaken: number; // Time in milliseconds
    clickedTargetPosition: string; // Add this property to the type
    success: boolean;
  };

  const handleTrialEnd = (trialData: TrialData) => {

    if (trialData.trialNumber === 1) {
      // Ajoutez les positions des cibles de cet essai aux positions existantes
      trialResults.current.positions.push(...trialData.positions);
    }

    // Ajoutez le résultat de l'essai aux résultats
    trialResults.current.results.push({
      trialNumber: trialData.trialNumber,
      timeTaken: trialData.timeTaken,
      clickedTargetPosition: trialData.clickedTargetPosition,
    });

  };

  const handleTestEnd = (trialDataSuccess: boolean) => {
    trialResults.current.success = trialDataSuccess;

    const fieldToSave = [
      { field: "sessionDate", value: new Date() },
      { field: "resultsExploration", value: JSON.stringify(trialResults.current) },
      { field: "status", value: "EN_COURS" }
    ];

    saveFieldSession(fieldToSave);
    toast.success("Les résultats ont bien été enregistrés");
    onModuleEnd();
  };

  if(!caseSize || caseSize === "undefined" || caseSize === "null" || caseSize === null || Number(caseSize) === 0) {
    return (
      <EcranInstructions instructions="Veuillez sélectionner une taille de case dans les paramètres avant de commencer le test." />
    );
  }


  return (
    <div>
      {!moduleActif ? (
        <EcranInstructions instructions="Appuyez sur espace pour commencer le test. Cliquez sur la cible pour passer à l'essai suivant." />
      ) : (
        <ExplorationTest
          caseSize={Number(caseSize)}
          totalTrials={totalTrials}
          onTrialEnd={handleTrialEnd}
          onTestEnd={handleTestEnd}
        />
      )}
    </div>
  );
};
